var e = {
	list: {
		title: "Trips",
		tabs: {
			active: "Active Trips",
			past: "Past"
		},
		empty: {
			title: "No trips yet",
			active: "Trips you book will show up here.",
			past: "Your completed trips will show up here."
		}
	},
	invitations: { title: "Booking invitations" },
	details: {
		title: "Your stay at {{listing}}",
		titleFallback: "Your stay at the listing",
		breadcrumb: "Trip Details",
		confirmation: "Conf. #{{id}}",
		hostDetails: "Host details",
		messageHostError: "Could not open the conversation. Please try again.",
		location: { title: "Where you'll be" },
		totalPaid: "Total Paid",
		listingFallback: "Listing",
		notFound: {
			title: "Trip not found",
			body: "This trip doesn't exist or isn't yours."
		}
	},
	slot: {
		byHost: "By {{host}}",
		seats_one: "{{count}} guest",
		seats_other: "{{count}} guests",
		startsAt: "Starts {{when}}",
		sessionTitle: "Your session",
		meetingPoint: "Meeting point",
		directions: "How to find it",
		duration: "Runs {{duration}}",
		timesIn: "Times shown in {{zone}}",
		reviewAfter: "You can review this after it ends."
	}
};
//#endregion
export { e as default };
